import { render, staticRenderFns } from "./SettingsSubPageHeader.vue?vue&type=template&id=cff432b8"
import script from "./SettingsSubPageHeader.vue?vue&type=script&lang=js"
export * from "./SettingsSubPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports